<template>

    <div class="rating-container">
        <div class="h2 heading">Wie gut hat Dir dieser Artikel gefallen?</div>
        <ul class="rating-listing">
            <li class="rating-label"
                v-for="rating in 5"
                v-bind:class="{'active' : rating <= ratingParam,'disabled' : ratingParam > 0, 'rating-listing-cookies-not-accepted disabled': !cookiesAccepted}"
                @click='setRating(rating)'>
            </li>
        </ul>
        <p class="rating-message"
              v-bind:class="[ratingMessage == null ? 'invisible' : '']"
              v-text="ratingMessage"
        ></p>
        <!-- Cookie consent overlay -->
        <div v-if="!cookiesAccepted" class="cookie-consent-overlay" @click.prevent="openCookieSettings">
            Bitte akzeptiere hier die funktionellen Cookies, um diesen Artikel zu bewerten:
          <a href="#" @click.prevent="openCookieSettings">Cookie-Einstellungen verwalten.</a>
        </div>
    </div>

</template>

<script>

// console.log('Home');

import wpApi from '../services/wpApi';

export default {
    created(){
        this.load();
    },
    props : {
        'pidParam' : {
            default : 0,
            type : Number,
        },
        /*'ratingParam' : {
            default : 0,
            type : Number,
        },*/
        'ratingMessage': {
            default: null,
            type: String
        }
    },
    data(){
        return {
            ratingParam: 0,
            cookiesAccepted: false,
            oneTrustLoaded: false,
            oneTrustPollingInterval: null,
        }
    },
    mounted() {
        this.startOneTrustPolling();
    },
    beforeDestroy() {
        this.removeOneTrustListener();
        if (this.oneTrustPollingInterval) {
            clearInterval(this.oneTrustPollingInterval);
        }
    },
    methods : {
        load(){
            this.ratingParam = this.getRating();
        },
        setRating(rate){
            if(!this.cookiesAccepted){
                return alert('Bitte akzeptiere die Cookies, um eine Bewertung abzugeben.');
            }
            if(this.ratingParam > 0 ) return;
            this.ratingMessage = null;

            // Use WordPress admin-ajax.php (NO REST API)
            const formData = new FormData();
            formData.append('action', 'nvv_rate_post');
            formData.append('post_id', this.pidParam);
            formData.append('rating', rate);
            formData.append('nonce', window.nvvRatingNonce || '');

            fetch(themeData.ajaxurl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if(data.success){
                    this.ratingParam = rate;
                    this.ratingMessage = 'Danke für Deine Bewertung!';
                    // Set cookie
                    document.cookie = `rated_${this.pidParam}=${rate}; path=/; max-age=${30 * 24 * 60 * 60}`;
                } else {
                    this.ratingMessage = data.message || 'Ein Fehler ist aufgetreten.';
                }
            })
            .catch(error => {
                console.error('Rating error:', error);
                this.ratingMessage = 'Ein Fehler ist aufgetreten.';
            });

        },
        getRating() {
            let name = 'rated_' + this.pidParam;
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return 0;
        },
        /**
         * Starts polling for the OneTrust script to be loaded.
         * Sets an interval that checks every 100 milliseconds if the OneTrust script is available.
         * Once the OneTrust script is detected, sets `oneTrustLoaded` to true and clears the interval.
         */
        startOneTrustPolling() {
            this.oneTrustPollingInterval = setInterval(() => { // check for OneTrust script to be loaded
                if (window.OneTrust && window.OneTrust.GetDomainData) {
                this.oneTrustLoaded = true;
                clearInterval(this.oneTrustPollingInterval);
                }
            }, 100);
        },
        /**
         * Sets up a listener for OneTrust consent changes.
        */
        setupOneTrustListener() {
            if (window.OneTrust) {
                window.OneTrust.OnConsentChanged(()=>{
                    this.checkCookieConsent();
                });
            }
        },

        /**
         * Removes the OneTrust consent change listener if it exists.
         */
         removeOneTrustListener() {
            if (window.OneTrust) {
                // window.OneTrust.RemoveOnConsentChangedHandler(this.handleConsentChangeRating);
            }
        },
        /**
         * Checks if the user has given consent for performance cookies (C0002).
         *
         * This method retrieves the active cookie consent groups from the `OnetrustActiveGroups` variable
         * and checks if the performance cookies group ("C0002") is included in the active groups.
         *
         * @returns {boolean} - Returns `true` if performance cookies consent is given, otherwise `false`.
         */
        checkCookieConsent() {
            // C0001 (Strictly Necessary), C0002 (Performance), C0003 (Functional), C0004 (Targeting)
            const activeGroups = OnetrustActiveGroups || "";
            this.cookiesAccepted =  activeGroups.includes("C0002");
            return this.cookiesAccepted;
        },
        /**
         * Handles the change in consent by checking the cookie consent status.
         */
         handleConsentChangeRating() {
            this.checkCookieConsent();
        },
        /**
         * Opens the cookie settings dialog using the OneTrust library.
         */
        openCookieSettings() {
            if (window.OneTrust) {
                window.OneTrust.ToggleInfoDisplay();
            }
        },
    },
    watch: {
        oneTrustLoaded(newValue) {
            if (newValue) {
                this.setupOneTrustListener();
                this.checkCookieConsent();
            }
        }
    },
}

</script>

<style lang="scss">

    @import '../../css/variables';

    .rating-container{
        .heading {
            margin-bottom: 15px;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: $color-nochvielvor-pink;

            @media screen and (min-width: 768px) {
                height: 32px;
                font-size: 25px;
                line-height: 1.28;
            }

        }
        .rating-listing{
            padding: 0;
            .rating-label {
                text-transform: uppercase;
                font-weight: 700;
                display: inline-block;
                background-image: url('/img/ic_star_gray.svg');
                background-repeat: no-repeat;
                width: 45px;
                height: 45px;
                &.active{
                    background-image: url('/img/ic_star_pink.svg');
                }
                &:not(.disabled){
                    cursor: pointer;
                }
            }
            .rating-listing-cookies-not-accepted {
                cursor: not-allowed !important;
            }
        }
        .rating-message{
            color: $color-nochvielvor-pink;
            font-weight: 700;
        }
        .cookie-consent-overlay {
            position: relative;
            color: #000;
            font-size: 11px;
            text-align: left;
        }
        .cookie-consent-overlay a{
            display: block;
            font-weight: bold;
            color: #000;
            margin-top: 5px;
        }
    }
</style>
